import { render } from "./CartTotals.vue?vue&type=template&id=28cbcd82"
import script from "./CartTotals.vue?vue&type=script&lang=js"
export * from "./CartTotals.vue?vue&type=script&lang=js"

import "./CartTotals.vue?vue&type=style&index=0&id=28cbcd82&lang=css"
script.render = render

export default script